import { render, staticRenderFns } from "./CircleLoader.vue?vue&type=template&id=32009226&scoped=true"
import script from "./CircleLoader.vue?vue&type=script&lang=ts"
export * from "./CircleLoader.vue?vue&type=script&lang=ts"
import style0 from "./CircleLoader.vue?vue&type=style&index=0&id=32009226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32009226",
  null
  
)

export default component.exports